import styled from 'styled-components';
import { DimensionsXs, DimensionsSm } from '@pegasus/ui-headers';
import { Title as UiTitle } from '@lux/title';
import { screenBiggerThan, Screen } from '@client/styles/styled-components/breakpoints';

// TODO: add #F6E3D3 color to complementary colors at ui-components
const complementaryOrange = '#F6E3D3';

export const Background = styled.div`
    margin-top: ${DimensionsXs.headerHeight};
    min-height: 400px;
    width: 100%;
    background-color: ${complementaryOrange};
    background-image: url('https://img01.ztat.net/zl-campaignC/safty_first_bg_m2.svg');
    background-position: top right;
    background-repeat: no-repeat;
    ${screenBiggerThan(Screen.mobile)} {
        margin-top: ${DimensionsSm.headerHeight};
        background-image: url('https://img01.ztat.net/zl-campaignC/safty_first_bg_d.svg');
    }
`;

export const Container = styled.div`
    width: 100%;
    margin: 0;
    padding: 0 16px;
    ${screenBiggerThan(Screen.mobile)} {
        width: 50%;
        margin-left: 10%;
        min-height: 400px;
    }
`;

export const Title = styled(UiTitle)`
    padding: 40px 0 20px;
    margin: 0;
`;

export const Paragraph = styled.div`
    padding: 24px 0;
    &:first-of-type {
        padding-top: 0;
    }
    & a {
        text-decoration: underline;
        color: inherit;
    }
`;

interface MoreContentProps {
    isShown: boolean;
}

interface MoreButtonProps {
    isShown: boolean;
}

export const MoreButton = styled.div<MoreButtonProps>`
    padding: 12px 0 124px;
    display: ${({ isShown }) => (isShown ? 'block' : 'none')};
`;

export const MoreContent = styled.div<MoreContentProps>`
    display: ${({ isShown }) => (isShown ? 'inline-block' : 'none')};
    overflow: hidden;
`;

export const ButtonContainer = styled.div`
    padding: 12px 0;
    display: block;
    &:nth-of-type(2) {
        padding-top: 24px;
    }
    &:last-of-type {
        padding-bottom: 60px;
    }
`;
